module.exports = __webpack_public_path__ + "fd1d15a033b63ef1080a0c3efd53a70a.svg";